<template>
  <div id="app_content" class="reserved">
    <div
        class="jumbo d-flex flex-column justify-content-center align-items-center"
    >
      <div class="logo">
        <img
            class="logo-img"
            :src="url('/media/icons/svg/logo4-belt.svg')"
            alt="Logo 4-Belt"
        />
        <h1 class="logo-txt my-3">{{ titolo }}</h1>
      </div>
    </div>

    <section
        v-for="(macro, i) in macrofamily"
        class="macrofamily"
        :class="(i % 2 === 0) ? 'bg-rotate' : ''"
        v-if="macro.codice !== 'MP'"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 d-flex align-items-center is-justify-content-center flex-row-reverse mx-0">
            <div class="my-title">
              <h1 v-if="macro.descrizione.match(/^\d/)" class="my-section">
                {{ macro.descrizione.slice(0, 1) + '-' + macro.descrizione.slice(1).charAt(0) }}{{
                  macro.descrizione.slice(2).toLowerCase()
                }}
              </h1>
              <h1 v-else class="my-h1">
                {{ macro.descrizione }}
              </h1>
              <a class="link-ret green btn btn-my-primary giallo"
                 :href="url('/b2b/macrofamily-article/' + macro.codice)"
              >{{ trans.get("b2b.explore") }}</a>
            </div>
          </div>
          <div class="col-md-6 bg-image">
            <img v-if="macro.codice !== 'ENG'" :src="url('/storage/media/image-page/b2b_home_' + macro.codice + '.jpg')"
                 alt="">
            <img class="eng" v-if="macro.codice === 'ENG'"
                 :src="url('/storage/media/image-page/b2b_home_' + macro.codice + '.jpg')" alt="">
          </div>

        </div>
      </div>
    </section>

    <!-- <section id="best">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="my-section">best sellers</h1>
            <div
              id="carouselExampleControlsNoTouching"
              class="carousel slide"
              data-touch="false"
              data-interval="false"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class="row">
                    <div
                      class="col-md-4 col-lg-3 px-6px"
                      v-for="(item, i) in 4"
                    >
                      <div class="card" style="width: 18rem">
                        <img src="" class="card-img-top" alt="..." />
                        <div class="card-body">
                          <h5 class="card-title">Card title</h5>
                          <span>{{ i }}</span>
                          <p class="card-text">
                            Some quick example text to build on the card title
                            and make up the bulk of the card's content.
                          </p>
                          <div class="card-btns d-flex justify-content-between">
                            <a
                              href="#"
                              class="
                                link-ret
                                green
                                btn btn-my-primary
                                text-capitalize
                              "
                              >scopri</a
                            >
                            <a
                              href="#"
                              class="
                                cart
                                link-ret
                                black
                                btn btn-my-primary
                                flex-shrink-1
                              "
                            >
                              <img
                                src="\media\icons\svg\cart1.svg"
                                alt="carrello"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="controls text-black-2 d-flex justify-content-between">
                <a
                  class="
                    carousel-control-prev
                    d-flex
                    justify-content-between
                    text-black-2
                  "
                  href="#carouselExampleControlsNoTouching"
                  role="button"
                  data-slide="prev"
                >
                  <img src="\media\icons\svg\arrow-left.svg" alt="indietro" />
                  <span class="text-capitalize text-black-2">indietro</span>
                </a>
                <a
                  class="
                    carousel-control-next
                    d-flex
                    justify-content-between
                    text-black-2
                    flex-row-reverse
                  "
                  href="#carouselExampleControlsNoTouching"
                  role="button"
                  data-slide="next"
                >
                  <img src="\media\icons\svg\arrow-right.svg" alt="avanti" />

                  <span class="text-capitalize text-black-2">avanti</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
export default {
  components: {},
  props: ["titolo"],
  data: function () {
    return {
      macrofamily: [],
    };
  },

  created: function () {
    this.loadFamily();
  },
  methods: {
    loadFamily: function () {
      var vue = this;

      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          type: "filter-m",
        },
      })
          .then((res) => {
           // console.log(res.data.family)
            if (res.data.family) vue.macrofamily = res.data.family;

            for (const key in vue.macrofamily) {
              for (var key1 in vue.macrofamily[key]) {
                // console.log(`${key1}: ${vue.macrofamily[key][key1]}`);
                vue.macrofamily[key] = {
                  ...vue.macrofamily[key],
                  background:
                      "/media/image-page/macrofamily-" +
                      vue.macrofamily[key].codice +
                      ".png",
                };
              }
            }
          })
          .catch((err) => {
            vue.loading = false;

            vue.$store.commit("add_message", {
              type: "error",
              message: err,
            });
          });
    },
  },
};
</script>


<style lang="scss" scoped>
.my-h1 {
  font-weight: normal;
  text-transform: lowercase;
  font-size: 32px;

  &::first-letter {
    text-transform: capitalize;
  }

}

.jumbo {
  background-image: url("/media/image-page/b2b_home.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 7%;
  padding: 82px 0;
  margin-bottom: 10px;

  .logo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      height: 90px;
    }

    h1 {
      font-size: 28px;
      color: #fff;
    }
  }
}

.container-fluid {
  padding: 0;
  margin: 0;

  .row {
    margin: 0;
    max-width: none;

    .my-section {
      h1 {
        font-weight: normal;
      }
    }
  }
}

.macrofamily {
  display: flex;
  background-color: #f5f5f5;
  //padding: 169px 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 10px;

  h1 {
    padding-bottom: 68px;
    color: var(--dark-gray) !important;
    font-size: 32px;
  }

  &.bg-rotate {
    //transform: rotateY(180deg);
    transform: scaleX(-1);

    .my-title {
      transform: scaleX(-1);
      //transform: rotateY(180deg);
      a {
        width: 200px;
      }
    }
  }

  .my-title {
    a {
      width: 200px;
    }
  }

  .bg-image {
    padding: 0;
    min-height: 370px;

    img {
      object-fit: cover;

    }

    .eng {
      transform: scaleX(-1);
      -webkit-transform: scaleX(-1);
    }
  }
}


#best {
  padding: 27px 0 47px;

  h1 {
    padding-bottom: 24px;
  }

  .col-md-3.px-6px {
    padding: 0 6px;

    .card {
      background-color: #f5f5f5;
      border: none;
      border-radius: 0;
      box-shadow: unset;

      a.link-ret {
        width: 66.5%;

        &.cart {
          width: 30.5%;
        }

        &:after {
        }
      }
    }
  }

  .controls.text-black-2 {
    padding-top: 96px;
    padding-right: 15px;

    a.carousel-control-next,
    a.carousel-control-prev {
      .icon {
        font-size: 20px;
      }

      .text {
        font-size: 15px;
      }

      span.text-black-2 {
        color: var(--black-2);
      }

      position: initial;
      width: 103px;
    }
  }
}

@media screen and (min-width: 992px) {
  .macrofamily {

  }
}

@media screen and (min-width: 1200px) {
  .jumbo {
    padding: 182px 0;
  }

  .macrofamily {

  }
}
</style>
